<template>
  <section class="why">
    <div class="container">
      <a-typography-title :level="1">
        <span>流量激增时，业务稳定性受冲击</span>
        <template v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)">，</template>
        <br v-else />
        <span>各类问题亟待解决</span>
      </a-typography-title>
      <a-row :gutter="[50,$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?20:5]">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :md="12" :lg="{offset:index%2?0:2,span:10}" :xl="{offset:index%2?0:3,span:9}">
          <div class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              <span v-for="v in item.text">
                {{ v }}
              </span>
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_why',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '资源及架构能力不足',
            text: [
              '访问量暴增，服务器如何承载？',
              '业务核心架构如何应对超预期增长？'
            ]
          },
          {
            title: '业务需要快速迭代',
            text: [
              '如何快速进行新业务的迭代发布部署？',
              '新业务的集群规模如何评估？'
            ]
          },
          {
            title: '全链路业务承载压力',
            text: [
              '如何建立准确的性能基线？',
              '除了主业务，哪些周边系统还会成为瓶颈？'
            ]
          },
          {
            title: 'IT成本亟待优化',
            text: [
              '支撑峰值的最小资源消耗是多少？',
              '缩短资源使用时间的技术手段有哪些？'
            ]
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/planStable/';

.why {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  @wh: 70px;
  position: relative;
  min-height: 92px;
  padding: 5px 0 5px 90px;
  
  .loop(@i) when (@i<=4) {
    &.i_@{i} {
      &::before {
        background-position-x: -(-1+@i)*@wh;
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &::before {
    content: '';
    display: block;
    .position(absolute, 0, auto, auto, 0);
    z-index: 0;
    width: @wh;
    height: @wh;
    .bg('@{image}why_icon.png', @wh*4, @wh);
  }
  
  h5.ant-typography {
    margin: 0;
    .font(justify, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    margin: @margin_mo 0 0;
    .font(justify, @text+@line, @color_13, @text);
    
    span {
      display: block;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .why {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    max-width: 350px;
    min-height: auto;
    padding: 0;
    margin: 0 auto;
    
    &::before {
      .position(absolute, -25px, auto, auto, -25px);
      margin: 0;
      .transform(scale(0.4));
    }
    
    h5.ant-typography {
      padding: 0 0 0 35px;
      margin: @margin_mo 0 0;
      .font(justify, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      margin: @margin_mo 0 0;
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }
}
</style>